import React, {Component} from 'react';
import {Switch} from "../buttons/Swtich";
import {UpdateItemsInListIcon} from "../elements/UpdateItemsInList";
import {MultiSelectItem} from "./MultiSelectItem";
import {Spinner} from "../Spinner";
import {FaIcon} from "../FaIcon";
import { withTranslation } from 'react-i18next';

class MultiSelectClass extends Component {
    constructor(props) {
        super(props);

        // A no ser que se mande false por paramétro, siempre empieza mostrando solo los activos
        const showOnlyActiveInitialStatus = this.props.showOnlyActiveInitialStatus !== false;

        this.state = {
            filteredItems: this._getInitialItems().filter((item) => {
                return this.hasToShowItem(item, "", showOnlyActiveInitialStatus)
            }),
            selectedItemIds: this._getInitialSelectedItemIds() || [],
            showOnlyActive: showOnlyActiveInitialStatus,
            inputTextValue: ""
        };
        this.handleChangeItem = this.handleChangeItem.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleUnselectAll = this.handleUnselectAll.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handleOnlyActiveChange = this.handleOnlyActiveChange.bind(this);
        this.handleRefreshListItems = this.handleRefreshListItems.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.items !== this.props.items) {
            this.setState({
                filteredItems: this._getInitialItems().filter((item) => {
                    return this.hasToShowItem(item, this.state.inputTextValue, this.state.showOnlyActive)
                })
            });
        }
    }

    handleChangeItem(event) {
        const isChecked = event.target.checked;
        const itemId = event.target.dataset.id;
        let selectedItems = null;
        if (isChecked) {
            selectedItems = this.state.selectedItemIds.concat([itemId]);
        } else {
            selectedItems = this.state.selectedItemIds.filter((selectedItem) => {
                return selectedItem !== itemId;
            });
        }
        this._setSelectedItems(selectedItems);
    }

    // helpers

    _setSelectedItems(selectedItems) {
        this.setState({selectedItemIds: selectedItems}, () => {
            this.props.onChange(this.state.selectedItemIds)
        });
    }

    _isSelected(itemId) {
        return this.state.selectedItemIds.includes(itemId);
    }

    _getInitialItems() {
        // Default mapping of the data of an item (classic model-like item).
        // Can be customized by setting 'itemDataMap' prop.
        const defaultItemDataMap = (item) => {
            // We don't know if item.id will be a string or int,
            // so we cast it to string internally, as strings are a more general case
            return {name: item.name, id: item.id.toString(), isActive: item.is_active}
        };

        const itemDataMap = this._getItemDataMap() || defaultItemDataMap;

        return this._getItems().map(itemDataMap);
    }

    _getItemDataMap() {
        return this.props.itemDataMap;
    }

    _getItems() {
        return this.props.items;
    }

    _getInitialSelectedItemIds() {
        // See this._getInitialItems() note.
        if (this.props.selectedItemIds !== undefined) {
            return this.props.selectedItemIds.map((itemId) => itemId.toString())
        } else {
            return undefined;
        }
    }

    // internal handlers

    handleFilter(event) {
        const inputTextValue = event.target.value;
        const showOnlyActive = this.state.showOnlyActive;
        const filteredItems = this._getInitialItems().filter((item) => {
            return this.hasToShowItem(item, inputTextValue, showOnlyActive)
        });
        this.setState({
            filteredItems: filteredItems,
            inputTextValue: inputTextValue
        });
    }

    handleRefreshListItems() {
        if(this.props.onRefreshListItems !== undefined)
            this.props.onRefreshListItems();
    }

    _getInactiveItemsAreLoaded() {
        return this.props.inactiveItemsAreLoaded !== undefined ? this.props.inactiveItemsAreLoaded : true;
    }

    handleOnlyActiveChange(event) {
        const showOnlyActive = event.target.checked;
        const inputTextValue = this.state.inputTextValue;

        if (!showOnlyActive && !this._getInactiveItemsAreLoaded()) {
            this.setState({
                showOnlyActive: showOnlyActive
            }, () => {
                this.props.onLoadInactiveItems();
            });
        }
        else {
            const filteredItems = this._getInitialItems().filter((item) => {
                return this.hasToShowItem(item, inputTextValue, showOnlyActive)
            });
    
            this.setState({
                showOnlyActive: showOnlyActive,
                filteredItems: filteredItems});
        }
    }

    hasToShowItem(item, inputTextValue, showOnlyActive) {
        return (item.name.toLowerCase().includes(inputTextValue.toLowerCase()) || (item.account_id !== undefined && item.account_id.toLowerCase().includes(inputTextValue.toLowerCase()))) && (!this.props.showOnlyActiveCheck || !showOnlyActive || item.isActive);
    }

    handleSelectAll(event) {
        event.preventDefault();

        const filteredItems = this._getInitialItems().filter((item) => {
            return this.hasToShowItem(item, this.state.inputTextValue, this.state.showOnlyActive)
        });

        this._setSelectedItems(filteredItems.map((item) => item.id));
    }

    handleUnselectAll(event) {
        event.preventDefault();
        this._setSelectedItems([]);
    }

    renderOnlyActiveCheck() {
        const { t } = this.props;
        if(this.props.showOnlyActiveCheck) {
            return <div className="is_active-toggl">
                <Switch onChange={this.handleOnlyActiveChange} checked={this.state.showOnlyActive}/>
                <span className="status-label">{t('multiselect.only_active')}</span>
            </div>
        }
        return null
    }

    renderRefreshList() {
        if(this.props.onRefreshListItems === undefined)
            return null;

        return <div className="refresh_list_items_icon">
            <UpdateItemsInListIcon
                message={this.props.messageForRefreshListItemsIconToolbox}
                isBeingSyncedOnDemand={this.props.isUpdatingListItems}
                onClick={this.handleRefreshListItems}
            />
        </div>

    }

    getMultiSelectClassName() {
        return (this.props.longList === true) ? "multi-select-list long" : "multi-select-list";
    }

    renderItems() {
        if (this.state.filteredItems.length === 0) {
            return this.renderEmptyFiltered();
        }
        return <ul key="multi-select-list" className={this.getMultiSelectClassName()}>
            {this.state.filteredItems.map((item) =>
                <MultiSelectItem
                    readOnly={this.props.readOnly}
                    key={item.id}
                    itemName={item.name} itemId={item.id}
                    onChange={this.handleChangeItem}
                    checked={this._isSelected(item.id)}
                />
            )}
        </ul>
    }

    renderEmptyFiltered() {
        const { t } = this.props;
        const totalItems = this._getInitialItems().length;
        const hasSearchText = this.state.inputTextValue.length > 0;
        const onlyActiveFilterOn = this.props.showOnlyActiveCheck && this.state.showOnlyActive;
        // Si el filtro client-side "Sólo activos" está ocultando todo, ofrecer apagarlo.
        const canShowInactive = totalItems > 0 && onlyActiveFilterOn && !hasSearchText;

        let hint;
        if (hasSearchText) {
            hint = t('multiselect.no_matches_search');
        } else if (canShowInactive) {
            hint = t('multiselect.no_matches_only_active');
        } else {
            hint = t('multiselect.no_matches');
        }

        return (
            <div key="multi-select-list" className={`${this.getMultiSelectClassName()} -empty`}>
                <div className="multi-select-empty">
                    <FaIcon iconName="filter"/>
                    <p className="multi-select-empty__hint">{hint}</p>
                    {canShowInactive ? (
                        <button
                            type="button"
                            className="btn -alt multi-select-empty__cta"
                            onClick={() => this.handleOnlyActiveChange({target: {checked: false}})}
                        >
                            <FaIcon iconName="eye"/>
                            <span>{t('multiselect.show_inactive')}</span>
                        </button>
                    ) : null}
                </div>
            </div>
        );
    }

    _getInputTextStyle() {
        if(this.props.showOnlyActiveCheck) {
            return {
                width:"70%",
                display: "inline-block",
                verticalAlign: "top"
            }
        }
    }

    showButtonsFilters() {
        return true;
    }


    renderButtonsFilters() {
        const { t } = this.props;
        if (this.state.filteredItems.length === 0) return null;
        if(!this.props.readOnly && this.showButtonsFilters()) {
            return (<div key="select-options" className="select-options">
                <button onClick={this.handleSelectAll}>{t('multiselect.select_all')}</button>
                <button onClick={this.handleUnselectAll}>{t('multiselect.remove_selection')}</button>
            </div>)
        }
        return null;
    }

    render() {
        const { t } = this.props;
        return <div style={{width:"100%", whiteSpace: "nowrap"}}>
            <input key="filter-items" name="filter-items" type="text" onChange={this.handleFilter} onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }} style={this._getInputTextStyle()} placeholder={t('multiselect.search_placeholder')}/>
            {this.renderRefreshList()}
            {this.renderOnlyActiveCheck()}
            {this.props.isLoadingInactiveItems ? <div className={this.getMultiSelectClassName()} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><Spinner color="blue"/></div> : this.renderItems()}
            {this.renderButtonsFilters()}
        </div>
    }
}

export const MultiSelect = withTranslation()(MultiSelectClass);
export { MultiSelectClass };
